
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceforpuneoutstation() {



    const cardData =
    {
        keyword: 'Corporate cab services for Pune Outstation ',
        heading: 'etravo : Corporate cab services for Pune Outstation',
"headingDescription": "eTravo offers dependable Corporate Cab Services for Pune Outstation travel, designed for businesses, executives, and teams requiring seamless intercity transportation. Whether it’s client meetings in Mumbai, corporate trips to Nashik, or business travel to nearby cities, eTravo ensures safe, punctual, and comfortable journeys with chauffeur-driven sedans, SUVs, and premium vehicles. With GPS-enabled fleets, professional drivers, and flexible one-way or round-trip plans, eTravo is the ideal partner for reliable outstation corporate travel from Pune.","top": "Top Corporate Cab Services for Pune Outstation with eTravo","topPlaces": [  {    "title": "Mumbai Corporate Route",    "description": "One of the busiest business travel routes from Pune, ideal for client meetings, corporate events, and executive trips with reliable cab services."  },  {    "title": "Nashik Business Travel",    "description": "A key destination for industrial and corporate visits, requiring comfortable and efficient outstation cab services for professionals."  },  {    "title": "Lonavala & Khandala Route",    "description": "Popular for corporate offsites, team outings, and business retreats, offering smooth and scenic travel options."  },  {    "title": "Aurangabad Corporate Trips",    "description": "An important city for business and industrial travel, often requiring long-distance cab services with experienced drivers."  },  {    "title": "Nagpur Business Connectivity",    "description": "Suitable for long-haul corporate travel, providing safe and comfortable intercity transport for executives and teams."  },  {    "title": "Kolhapur Corporate Travel",    "description": "A growing business destination where companies frequently require dependable outstation transportation services."  },  {    "title": "Satara Industrial Visits",    "description": "Common for corporate and factory visits, making it a key route for professional travel from Pune."  },  {    "title": "Solapur Business Trips",    "description": "An emerging commercial hub requiring reliable cab services for smooth corporate travel and meetings."  },  {    "title": "Hyderabad Intercity Travel",    "description": "Ideal for extended corporate journeys, offering premium cab services for long-distance executive travel."  },  {    "title": "Bangalore Corporate Route",    "description": "A major IT and business corridor, frequently used by professionals requiring comfortable and efficient intercity cab services."  }],


"services": [
{
"name": "Corporate Outstation Cab Pune",
"description": "eTravo offers reliable corporate outstation cab services in Pune for businesses that require smooth intercity travel. Whether it’s client meetings, site visits, or corporate trips, our service ensures comfortable long-distance journeys with professional chauffeurs and well-maintained vehicles."
},
{
"name": "Outstation Corporate Taxi Pune",
"description": "Our outstation corporate taxi services in Pune are designed for efficient and hassle-free business travel. From one-way trips to round journeys, eTravo ensures timely pickups, safe travel, and a comfortable experience for executives and teams traveling outside the city."
},
{
"name": "Business Travel Cab Pune",
"description": "eTravo provides business travel cabs in Pune for professionals who need dependable transport for meetings, conferences, and corporate visits. Our services are focused on punctuality, comfort, and smooth travel to ensure productivity during business journeys."
},
{
"name": "Corporate Cab Hire Outstation Pune",
"description": "Choose eTravo’s corporate cab hire for outstation travel in Pune for reliable and flexible business transportation. Our vehicles are ideal for long-distance travel, offering comfort, safety, and professional service for corporate clients."
},
{
"name": "Company Outstation Taxi Pune",
"description": "eTravo offers company outstation taxi services in Pune tailored for organizational travel needs. Whether it’s employee trips or executive travel, our taxis provide a seamless and efficient solution for intercity transportation."
},
{
"name": "Corporate Intercity Cab Pune",
"description": "Our corporate intercity cab services in Pune are perfect for business travel between cities. With experienced drivers and well-maintained cars, eTravo ensures smooth and timely travel for corporate clients across multiple destinations."
},
{
"name": "Office Trip Cab Pune",
"description": "eTravo provides office trip cab services in Pune for corporate outings, team travel, and official trips. Our services ensure safe and comfortable group travel with flexible scheduling and reliable transportation."
},
{
"name": "Business Tour Taxi Pune",
"description": "Plan your business tours easily with eTravo’s business tour taxi services in Pune. We offer dependable transport solutions for corporate travel, ensuring smooth journeys for meetings, site inspections, and business expansions."
},
{
"name": "Corporate Travel Cab Pune",
"description": "eTravo’s corporate travel cab services in Pune are designed for both local and outstation business travel. Our vehicles provide comfort and reliability, helping professionals travel efficiently without delays or inconvenience."
},
{
"name": "Long Distance Corporate Taxi Pune",
"description": "For extended travel needs, eTravo offers long distance corporate taxi services in Pune. Our vehicles are equipped for comfortable journeys over long routes, ensuring safety, punctuality, and a stress-free travel experience."
},
{
"name": "Outstation Company Cab Pune",
"description": "eTravo provides outstation company cab services in Pune for businesses requiring dependable travel solutions beyond city limits. Our services ensure smooth coordination, timely travel, and professional service for all corporate trips."
},
{
"name": "Corporate Travel Services Pune",
"description": "Our corporate travel services in Pune cover complete transportation needs for businesses. From planning routes to executing journeys, eTravo ensures efficient and reliable travel management for employees and executives."
},
{
"name": "Employee Outstation Cab Pune",
"description": "eTravo offers employee outstation cab services in Pune for workforce travel across cities. Our solutions ensure safe, comfortable, and timely transportation for employees traveling for official purposes."
},
{
"name": "Business Cab Outstation Pune",
"description": "Our business cab outstation services in Pune are ideal for professionals traveling for work. With clean vehicles and experienced drivers, eTravo ensures a smooth and productive travel experience for every journey."
},
{
"name": "Corporate Trip Taxi Pune",
"description": "eTravo provides corporate trip taxi services in Pune for business tours and official travel. Our taxis are designed for comfort and reliability, ensuring a seamless journey for executives and teams traveling for corporate purposes."
}
],
"tableData": [
["Corporate Outstation Cab Pune", "Outstation Corporate Taxi Pune"],
["Business Travel Cab Pune", "Corporate Cab Hire Outstation Pune"],
["Company Outstation Taxi Pune", "Corporate Intercity Cab Pune"],
["Office Trip Cab Pune", "Business Tour Taxi Pune"],
["Corporate Travel Cab Pune", "Long Distance Corporate Taxi Pune"],
["Outstation Company Cab Pune", "Corporate Travel Services Pune"],
["Employee Outstation Cab Pune", "Business Cab Outstation Pune"],
["Corporate Trip Taxi Pune", ""]
],





"whychoose": [
    {
      "WhyChooseheading": "Specialized Corporate Outstation Cab Services from Pune",
      "WhyChoosedescription": "eTravo offers dedicated corporate cab services for Pune outstation travel, ensuring smooth intercity transportation for business meetings, site visits, and corporate tours across Maharashtra and beyond."
    },
    {
      "WhyChooseheading": "Wide Range of Vehicles for Long-Distance Travel",
      "WhyChoosedescription": "Our fleet includes sedans, SUVs, and premium vehicles ideal for long-distance corporate travel, providing comfort and flexibility based on team size and travel requirements."
    },
    {
      "WhyChooseheading": "Flexible One-Way and Round Trip Options",
      "WhyChoosedescription": "We provide one-way, round-trip, and multi-day outstation cab services, allowing businesses to plan travel efficiently without unnecessary costs or restrictions."
    },
    {
      "WhyChooseheading": "Professional Chauffeurs for Intercity Travel",
      "WhyChoosedescription": "Our experienced drivers ensure safe, smooth, and efficient long-distance journeys, with strong route knowledge and a focus on corporate professionalism."
    },
    {
      "WhyChooseheading": "On-Time Departure and Reliable Scheduling",
      "WhyChoosedescription": "Timely pickups and well-planned travel schedules help businesses maintain punctuality for meetings, events, and project deadlines across cities."
    },
    {
      "WhyChooseheading": "Transparent Pricing for Outstation Trips",
      "WhyChoosedescription": "eTravo provides clear pricing with no hidden charges, making it easier for companies to manage travel budgets for intercity and long-distance corporate trips."
    },
    {
      "WhyChooseheading": "Safe, Comfortable, and Well-Maintained Vehicles",
      "WhyChoosedescription": "All vehicles are regularly serviced and equipped for long journeys, ensuring comfort, safety, and a hassle-free corporate travel experience." 
    },
    {
      "WhyChooseheading": "24/7 Support for Corporate Travel Needs",
      "WhyChoosedescription": "Our support team is available round the clock to manage bookings, last-minute changes, and emergency travel requirements for outstation corporate trips."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What are corporate cab services for Pune outstation travel?',
            answer: 'Corporate cab services for Pune outstation travel include chauffeur-driven intercity transportation for business meetings, site visits, corporate events, and employee travel outside Pune.',
        },
        {
            question: 'Can I book one-way corporate outstation cabs from Pune?',
            answer: 'Yes, eTravo offers one-way outstation corporate cab services, helping businesses reduce travel costs by avoiding return charges.',
        },
        {
            question: 'Do you provide round-trip corporate travel from Pune?',
            answer: 'Yes, we offer round-trip and multi-day outstation cab services for corporate travel across cities and states.',
        },
        {
            question: 'Which vehicles are available for outstation corporate travel?',
            answer: 'Our fleet includes hatchbacks, sedans, SUVs, and luxury cars suitable for long-distance corporate travel needs.',
        },
        {
            question: 'Are drivers experienced for long-distance corporate travel?',
            answer: 'Yes, all drivers are trained, experienced, and knowledgeable about intercity routes, ensuring safe and smooth travel.',
        },
        {
            question: 'Can I customize corporate outstation travel plans?',
            answer: 'Yes, we provide flexible and customized travel plans based on company schedules, destinations, and duration.',
        },
        {
            question: 'Is the service available 24/7 for outstation travel?',
            answer: 'Yes, eTravo operates 24/7 to support corporate outstation travel at any time.',
        },
        {
            question: 'Do you provide GST billing for corporate outstation trips?',
            answer: 'Yes, we provide GST-compliant invoices for all corporate bookings for easy accounting.',
        },
        {
            question: 'Are your vehicles suitable for long journeys?',
            answer: 'Yes, all vehicles are well-maintained, comfortable, and equipped for long-distance travel to ensure a smooth experience.',
        },
        {
            question: 'How can I book corporate outstation cab services from Pune?',
            answer: 'You can book easily through our website or contact our support team for quick corporate booking assistance.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Nikhil Jadhav',
        designation: 'Project Manager, InfraBuild Pvt Ltd, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s corporate outstation cab service from Pune is extremely reliable. Their punctuality and comfortable vehicles make business travel smooth and stress-free.”',
    },
    {
        name: 'Ms. Ritu Agarwal',
        designation: 'Business Operations Lead, GlobalEdge Solutions',
        rating: [1, 1, 1, 1, 1],
        text: '“We regularly use eTravo for intercity corporate travel from Pune. Their flexible plans and professional drivers ensure a seamless experience every time.”',
    },
];












    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services for Pune Outstation",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-outstation-pune.jpg",
  "description": "Dependable corporate outstation cab services in Pune by eTravo. Ideal for business trips, intercity travel, office tours, and long-distance corporate taxi requirements with safe and timely service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-services-for-pune-outstation"
  }
};







    return (
        <div>
<Helmet>
  <title>Corporate Cab Services for Pune Outstation | Business Travel & Intercity Taxi | eTravo</title>
  <meta 
    name="description" 
    content="Book corporate outstation cab services in Pune with eTravo for business trips, intercity travel, office tours, and long-distance corporate taxi needs. Reliable and comfortable rides." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/123.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceforpuneoutstation;